import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import * as services from "../../../store/service";
import { ApplicationState } from "../../../store/index";
interface IProps {
    closeButtonText: string;
    onCloseCallback: any;
    openAsDialog: boolean;
    continueButtonText: string;
    onContinueButtonCallback: any;
    callInReason: string; // "manual-authentication" | "thin-client" | "l3-last-try-timeout" | "l3-last-try-fail" | "locked-not-enough-info"
    l3Case?: string; // "credit-report" | "credit-service" | "credit-alert" | "FAM-alert" | null
    l3Provider?: string; // 'CSID' | 'TUI'
}
const L3CallInComponent: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang } = useTranslation();
    let authData = useSelector((state: ApplicationState) => {
        if (
            state.configurationState &&
            state.configurationState.configuration &&
            state.configurationState.configuration.partnerConfig &&
            state.configurationState.configuration.partnerConfig.partnerProvider === "IDF"
        ) {
            return {
                isIDFUser: true,
            };
        }
        return { isIDFUser: "" };
    });
    
    const message: any = {
        "manual-authentication": tLang("dashboard.creditScore.l3CallInComp.manual-authentication"),
        "full-ssn-failed": tLang("dashboard.creditScore.l3CallInComp.full-ssn-failed"),
        "thin-client": tLang("dashboard.creditScore.l3CallInComp.thin-client"),
        "l3-timeout-locked": tLang("dashboard.creditScore.l3CallInComp.l3-timeout-locked"),
        "l3-last-try-fail": tLang("dashboard.creditScore.l3CallInComp.l3-last-try-fail"),
        locked:tLang("credit.creditScore.creditScoreWidget.ssnAuthError.verifyYourIdentity.locked"),
        "l3-otp-locked": tLang("credit.creditScore.creditScoreWidget.ssnAuthError.verifyYourIdentity.l3-otp-locked"),
        "locked-not-enough-info": tLang("dashboard.creditScore.l3CallInComp.locked-not-enough-info"),
    };

    const [isExperianL3Required, setIsExperianL3Required] = useState(false);
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const legalName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.legalName
            ? state.configurationState.configuration.partnerConfig.legalName
            : ""
    );
    const partnerDisplayName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerDisplayName
            ? state.configurationState.configuration.partnerConfig.partnerDisplayName
            : ""
    );
    const originSiteUrl = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.originSiteUrl
            ? state.configurationState.configuration.partnerConfig.originSiteUrl
            : ""
    );

    let strCloseButtonText = tLang("dashboard.creditScore.l3CallInComp.logout");
    let strContinueButtonText = tLang("dashboard.creditScore.l3CallInComp.finishVerification");
    let blnOpenAsDialog = false;
    let strL3Provider = "CSID";

    // set default value for props, if not passed
    if (props.closeButtonText != null) {
        strCloseButtonText = props.closeButtonText;
    }
    if (props.continueButtonText != null) {
        strContinueButtonText = props.continueButtonText;
    }
    if (props.openAsDialog != null) {
        blnOpenAsDialog = props.openAsDialog;
    }
    if (props.l3Provider != null) {
        strL3Provider = props.l3Provider;
    }

    let brandName = "";
    //if (isTUUser && isExperianL3Required) {
    //    brandName = tLang('dashboard.creditScore.l3CallInComp.memberServices');
    //} else if (strL3Provider === 'TUI') {
    //    brandName = 'IdentityForce';
    //}

    // Showing brand name on the basis of legalName or originSiteUrl
    const getBrandName = (str: string) => {
        if (str.includes("identityforce")) {
            brandName = "IdentityForce";
        } else if (str.includes("cyberscout")) {
            brandName = "Cyberscout";
        } else if (str.includes("sontiq")) {
            brandName = "Sontiq";
        } else if (str.includes("ezshield")) {
            brandName = "EZShield";
        } else {
            brandName = partnerDisplayName;
        }
    };

    if (legalName) {
        getBrandName(legalName.toLowerCase());
    } else {
        getBrandName(originSiteUrl.toLowerCase());
    }

    // in case of dialog, register event for escape press
    if (blnOpenAsDialog) {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                window.removeEventListener("keyup", () => {});
                onClose("cancel");
            }
        });
    }

    const onClose = (reason?: string) => {
        // execute method passed as props for onCloseButtonClick
        if (props.onCloseCallback != null) {
            props.onCloseCallback({ reason: reason == null ? "close" : "cancel" });
        }
    };
    const invokePostSubmitCallback = (status: string, data: any) => {
        if (props.onContinueButtonCallback != null) {
            props.onContinueButtonCallback({ status: status, data: data });
        }
    };
    const onSubmit = () => {
        invokePostSubmitCallback("success", "continue");
        onClose("close");
    };

    const checkIfExperianL3Required = () => {
        services.isExperialL3Required().then((response) => {
            if (response && response.hasError === false) {
                setIsExperianL3Required(response.isExperianL3Required);
            }
        });
    };


    useEffect(() => {
        checkIfExperianL3Required();
    }, []);

    
    return (
        <React.Fragment>
            <div className="row" id="content">
                <div className="box col-xs-12">
                    { (
                        <div className="dialog-header">
                            <h2>
                                <span className="dialog-icon status-default">
                                    <em className="las la-exclamation-triangle"></em>
                                </span>
                                &nbsp;{tLang("credit.creditScore.creditScoreWidget.ssnAuthError.verifyYourIdentity.title")}
                            </h2>
                        </div>
                    )}
                    <div className="dialog-body">
                       {<p>{message[props.callInReason]}</p>} 
                     
                     
                        {props.callInReason === "full-ssn-failed" ? (
                            <p>
                                {tLang("dashboard.creditScore.l3CallInComp.callingInstruction")},{" "}
                                <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>
                            </p>
                        ) : (
                            <>
                                {(
                                    <p>
                                        {tLang("credit.creditScore.creditScoreWidget.ssnAuthError.verifyYourIdentity.description2")}{" "}
                                        <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber} </a>
                                        {tLang("credit.creditScore.creditScoreWidget.ssnAuthError.verifyYourIdentity.description3")}
                                    </p>
                                )}
                            </>
                        )}
                        <br />
                        <div className="l3-manual-auth-actions">
                            <div className="row">
                                {props.callInReason === "full-ssn-failed" ? (
                                    <a
                                        href="/"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            onClose();
                                        }}
                                    >
                                        {strCloseButtonText}
                                    </a>
                                ) : (
                                    <>
                                        
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    {!props.openAsDialog && (
                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null"></div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-primary" onClick={() => onClose()}>
                                        <span className="btn-text">{strCloseButtonText}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default L3CallInComponent;
